import React from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'
import SVGIcon from '../helpers/icons'
import useNavigationManager from '../hooks/use-navigation-manager'

function PortModalItem (props) {

  const manager = usePortManager()
  const nav_manager = useNavigationManager()

  const is_current = manager.currentPort.port_id === props.port.port_id
  const current_mark = is_current ? <figure className={'current'}><SVGIcon type={'checkmark'}
                                                                           className={'port-modal-icon'}/></figure> :
    <figure className={'not-current'}></figure>
  const delete_button = !is_current ? <button className={'delete'} onClick={() => deletePort()}><SVGIcon type={'delete'}
                                                                                                         className={'port-modal-icon'}/>
  </button> : null

  const changePort = function () {
    manager.changePort(props.port.port_id)
    let lastAccesibleStep = manager.getLastAccesibleStep()
    if (nav_manager.currentStep > lastAccesibleStep) {
      nav_manager.setStep(lastAccesibleStep)
    }
  }

  const deletePort = function () {
    manager.deletePort(props.port.port_id)
  }

  return (
    <li className={'port-modal-item'} onClick={() => changePort()}>
            <span className={'port-modal-item__text-wrap'}>
                {current_mark}
              <span className={'port-modal-item__text'}>{props.port.name}</span>
            </span>
      {delete_button}
    </li>
  )
}

export default observer(PortModalItem)